import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateLeadByThread as CreateLeadByThreadMutation,
    LeadCreateByThreadInput,
    CreateLeadByThreadVariables,
} from 'nutshell-graphql-types';

import LEAD_CREATE_BY_THREAD from '../mutations/create-lead-by-thread.graphql';
import GET_THREAD from '../queries/get-inbox-thread.graphql';

export const useCreateLeadByThread = (): {
    createLeadByThread: (input: LeadCreateByThreadInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createLeadByThread, {loading, error}] = useMutation<
        CreateLeadByThreadMutation,
        CreateLeadByThreadVariables
    >(LEAD_CREATE_BY_THREAD);

    return {
        createLeadByThread: (input: LeadCreateByThreadInput) =>
            createLeadByThread({
                variables: {input},
                refetchQueries: [
                    {
                        query: GET_THREAD,
                        variables: {threadId: input.threadId},
                    },
                ],
                awaitRefetchQueries: true,
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
